<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ data.Name }}</p>
    </div>
    <div class="bottom_content">
      <a class="link" href="javascript:;" @click="openUrl(data)">
        <dl class="survey-share flex">
          <dt>
            <van-image
              height="50"
              :src="api.FileHost + tenant.LogoSmall"
              width="50"
            />
          </dt>
          <dd class="flex flex-v flex-pack-center">
            <h4>{{ data.SurveyTitle }}</h4>
            <p>
              点击作答【{{ data.SurveyTitle }}】
              <span v-if="data.SurveyType === 1">问卷</span>
              <span v-if="data.SurveyType === 2">测评</span>
            </p>
          </dd>
        </dl>
      </a>
      <div
        v-if="
          data.ResultId && data.ResultId != '0' && data.ResultSurveyType === 1
        "
        class="answer"
      >
        【
        <a href="javascript:'" @click="showAnswer(data)">我的作答</a>
        】
      </div>
    </div>
  </div>
  <OpenIframe ref="OpenIframe" @close="iframeClose" />
</template>
<script>
  import store from '@/store'
  import OpenIframe from '@/components/OpenIframe'
  import api from '@/api'
  export default {
    name: 'SurveyShare',
    components: {
      OpenIframe,
    },
    props: {
      data: {
        type: Object,
        default() {
          return {}
        },
      },
      nodeStatus: {
        type: Number,
        default: 0,
      },
      // 更新当前课程
      updateItem: {
        type: Function,
        default: null,
      },
    },
    data() {
      return {
        api,
        tenant: {},
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        this.tenant = await store.getters['user/getTenant']
      },
      async openUrl(item) {
        if (this.nodeStatus === 30) return
        const H5Url = await store.getters['system/getH5Url']
        let url = `${H5Url}survey/#/`
        if (item.SurveyType === 1) {
          url += `survey/dispatch/${item.DispatchId}`
        }

        if (item.SurveyType === 2) {
          url += `test/dispatch/${item.DispatchId}`
        }
        const params = this.$route.params
        url += `?formId=${params.id}&moduleInstanceId=${item.ModuleInstanceId}`
        this.$refs['OpenIframe'].show(url, item.SurveyTitle)
        // if (url.substring(0, 5) === 'https') {
        //   OpenIframe.value.show(url, '查看链接')
        // }
      },
      async showAnswer(item) {
        const H5Url = await store.getters['system/getH5Url']
        const url = `${H5Url}/survey/#/survey/answer/${
          item.ResultId
        }?type=resultId&preview=true&rand=${Math.random()}`
        this.$refs['OpenIframe'].show(url, item.SurveyTitle)
      },
      iframeClose() {
        this.$parent.getNodeModulesInfo()
      },
    },
  }
</script>
<style lang="scss" scoped>
  .bottom_content {
    padding: 12px;
  }
  .link {
    display: block;
    padding: 12px;
    border: 1px solid #efefef;
    line-height: 1;
    color: #666;
    border-radius: 9px;
    dt {
      height: 50px;
    }
    dl,
    dt,
    dd {
      margin: 0;
    }
    dd {
      padding-left: 12px;
      h4 {
        font-weight: normal;
        color: #333;
        font-size: 16px;
      }
      p {
        font-size: 14px;
        color: #999;
        margin-top: 6px;
        line-height: 1.2;
      }
    }
  }
  .answer {
    color: #333;
    padding-top: 10px;
    a {
      color: #1890ff;
    }
  }
</style>
